"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const trans_1 = require("@common/tsutils/trans");
const DimensionToolBarItem_vue_1 = __importDefault(require("@becrop/components/Results/AreaProjectMap/Components/Tools/DimensionToolBarItem.vue"));
let DimensionToolBar = class DimensionToolBar extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.dimensions = [
            {
                'hook': 'taxonomicals',
                'label': (0, trans_1.trans)('results_view_map.tools_list.taxo'),
                'disabled': true
            },
            {
                'hook': 'metrics',
                'label': (0, trans_1.trans)('results_view_map.tools_list.metrics'),
                'disabled': true
            },
            {
                'hook': 'advanced',
                'label': (0, trans_1.trans)('results_view_map.tools_list.advanced'),
                'disabled': false
            },
        ];
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    changeDimension(hook) {
        this.$emit('changeDimension', hook);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'horizontal' })
], DimensionToolBar.prototype, "orientation", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'taxonomicals' })
], DimensionToolBar.prototype, "activeDimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], DimensionToolBar.prototype, "theme", void 0);
DimensionToolBar = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            DimensionToolBarItem: DimensionToolBarItem_vue_1.default,
        },
    })
], DimensionToolBar);
exports.default = DimensionToolBar;
